export const formatDateTime = (date) => {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    minute = minute < 10 ? ('0' + minute) : minute;
    return y + '-' + m + '-' + d+' '+h+':'+minute;
}

export const formatDate = (date) => {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    return y + '-' + m + '-' + d;
}

export const formatDate2 = (date) => {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    return y + '-' + m;
}
export const formatDate3 = () => {
  var timeArr = [];
  let date = new Date();
  var y = date.getFullYear();
  var m = date.getMonth();
  var d = date.getDate();

  date.setDate(date.getDate()+40);
  var yy = date.getFullYear();
  var mm = date.getMonth();//获取当前月份的日期
  var ddd = date.getDate();
  timeArr[0] = y;
  timeArr[1] = m;
  timeArr[2] = d;
  timeArr[3] = yy;
  timeArr[4] = mm;
  timeArr[5] = ddd;
  return timeArr;
}

export const GetDateStr  = (AddDayCount) => {
    var dd = new Date();
    dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
    var y = dd.getFullYear();
    var m = dd.getMonth()+1;//获取当前月份的日期
    var d = dd.getDate();
    return y+"-"+m+"-"+d;
}
export const GetDateStr1  = (AddDayCount,dd) => {
  var arr = [];
  var nowDate = new Date();
  dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
  var y = dd.getFullYear();
  var m = dd.getMonth()+1;//获取当前月份的日期
  m = m < 10 ? ('0' + m) : m;
  var d = dd.getDate();
  d = d < 10 ? ('0' + d) : d;
  arr[0] = y+"-"+m+"-"+d;

  var date1 = Date.parse(formatDate(nowDate));
  var date2 = Date.parse(formatDate(dd));
  //计算两个日期之间相差的毫秒数的绝对值
  var ms= Math.abs(date2 - date1);
  //毫秒数除以一天的毫秒数,就得到了天数
  var days=(date2 - date1)/(1*24*60*60*1000);
  // console.log("天数:" + days);
  if (days === 0){
    arr[1] = "今天"
  }else if (days === 1){
    arr[1] = "明天"
  }else if (days === 2){
    arr[1] = "后天"
  }else if (days > 2){
    let newWeek = "周" + "日一二三四五六".charAt(dd.getDay());
    arr[1] = newWeek;
    // console.log(newWeek)
  }
  return arr;
}

export const nowGetDateStr  = (AddDayCount) => {
  var arr = [];
  var dd = new Date();
  var endDate = new Date();
  dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
  var y = dd.getFullYear();
  var m = dd.getMonth()+1;//获取当前月份的日期
  m = m < 10 ? ('0' + m) : m;
  var d = dd.getDate();
  d = d < 10 ? ('0' + d) : d;
  arr[0] = y+"-"+m+"-"+d;

  var date1 = Date.parse(formatDate(endDate));
  var date2 = Date.parse(formatDate(dd));
  //计算两个日期之间相差的毫秒数的绝对值
  var ms= Math.abs(date2 - date1);
  //毫秒数除以一天的毫秒数,就得到了天数
  var days=(date2 - date1)/(1*24*60*60*1000);
  // console.log("天数:" + days);
  if (days === 0){
    arr[1] = "今天"
  }else if (days === 1){
    arr[1] = "明天"
  }else if (days === 2){
    arr[1] = "后天"
  }else if (days > 2){
    let newWeek = "周" + "日一二三四五六".charAt(dd.getDay());
    arr[1] = newWeek;
    // console.log(newWeek)
  }
  return arr;
}

export const timeCoverTS = (time) => {
  var s = '';

  var hour = time.split(':')[0];
  var min = time.split(':')[1];
  var sec = time.split(':')[2];

  s = Number(hour*3600) + Number(min*60) + Number(sec);

  return s;
}

export const TSCoverTime = (s) => {
  var t;
  if(s > -1){
    var hour = Math.floor(s/3600);
    var min = Math.floor(s/60) % 60;
    var sec = s % 60;
    if(hour < 10) {
      t = '0'+ hour + ":";
    } else {
      t = hour + ":";
    }

    if(min < 10){t += "0";}
    t += min + ":";
    if(sec < 10){t += "0";}
    t += sec.toFixed(2);
  }
  return t;
}

export const getNowFormatDate = () => {
  var timeArr = [];
  var date = new Date();
  var seperator1 = ".";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  let hour = date.getHours(); //获取当前小时数(0-23)
  let minute = date.getMinutes(); //获取当前分钟数(0-59)
  let second = date.getSeconds(); //获取当前秒数(0-59)
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  if (hour >= 0 && hour <= 9) {
    hour = "0" + hour;
  }
  if (minute >= 0 && minute <= 9) {
    minute = "0" + minute;
  } if (second >= 0 && second <= 9) {
    second = "0" + second;
  }
  let nowDate = year + seperator1 + month + seperator1 + strDate;
  let newWeek = "星期" + "日一二三四五六".charAt(new Date().getDay());
  let newTime =  hour + seperator1 + minute + seperator1 + second;
  // let newTime = this.fillZero(hour) + seperator1 + this.fillZero(minute) + seperator1 + this.fillZero(second)
  this.newDate=nowDate+'\xa0\xa0\xa0'+newWeek +'\xa0\xa0\xa0'+ newTime;
  timeArr[0]=nowDate;
  timeArr[1]=newWeek;
  timeArr[2]=strDate;
  timeArr[3]=nowDate+'-'+strDate;
  return timeArr;
}
export const addTime = (time) => {

  console.log(time)
  const hourTime1 = parseInt(time.slice(0,2));
  const minuteTime1 = parseInt(time.slice(3,5));
  const secondTime1 = parseInt(time.slice(6,8));

  let value = hourTime1*3600+minuteTime1*60+secondTime1+7200;
    let secondTime = parseInt(value); // 秒
  console.log(secondTime)
    let minuteTime = 0; // 分
    let hourTime = 0; // 小时
    if(secondTime > 60) { // 如果秒数大于60，将秒数转换成整数
      // 获取分钟，除以60取整数，得到整数分钟
      minuteTime = parseInt(secondTime / 60);
      // 获取秒数，秒数取佘，得到整数秒数
      secondTime = parseInt(secondTime % 60);
      // 如果分钟大于60，将分钟转换成小时
      if(minuteTime > 60) {
        // 获取小时，获取分钟除以60，得到整数小时
        hourTime = parseInt(minuteTime / 60);
        // 获取小时后取佘的分，获取分钟除以60取佘的分
        minuteTime = parseInt(minuteTime % 60);
      }
    }
    let result
    // 秒数为0返回空
    if (secondTime > 0) {
      result = "" + parseInt(secondTime) + "秒";
    } else {
      result = "00"
    }
    if(minuteTime > 0) {
      result = "" + parseInt(minuteTime) + ":" + result;
    }
    if(hourTime > 0) {
      result = "" + parseInt(hourTime) + ":" + result;
    }
    console.log(result)
    return result

}



// WEBPACK FOOTER //
// ./src/common/common.js